import { render, staticRenderFns } from "./FullWidthLayout.vue?vue&type=template&id=74e4cbaf"
import script from "./FullWidthLayout.vue?vue&type=script&lang=js"
export * from "./FullWidthLayout.vue?vue&type=script&lang=js"
import style0 from "./FullWidthLayout.vue?vue&type=style&index=0&id=74e4cbaf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports